module.exports = __webpack_public_path__ + "img/sr3_slide_2.369d663e.jpg";